const { configurations } = require(`./configurations.js`)

const router = {
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   redirect: '/home',
    // },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/modules/home/views/pages/HomePadrao.vue'),
      meta: {
        configurations: configurations
      }
    },
    {
      path: '/cadastro',
      name: 'cadastro',
      component: () => import('@/modules/users/views/pages/CadastroPadrao.vue'),
      meta: {
        configurations: configurations
      }
    },
    {
      path: '/cliente-cadastrado',
      name: 'cliente-cadastrado',
      component: () => import('@/modules/users/views/pages/ClienteCadastrado.vue'),
      meta: {
        configurations: configurations
      }
    },
    {
      path: '/dados-alterados',
      name: 'dados-alterados',
      component: () => import('@/modules/users/views/pages/FinalizarPadrao.vue'),
      meta: {
        configurations: configurations
      }
    },
    {
      path: '/solicitacao-realizada',
      name: 'solicitacao-realizada',
      component: () => import('@/modules/users/views/pages/SolicitacaoRealizada.vue'),
      meta: {
        configurations: configurations
      }
    },
    {
      path: '/finalizar',
      name: 'finalizar',
      component: () => import('@/modules/users/views/pages/FinalizarPadrao.vue'),
      meta: {
        configurations: configurations
      }
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: () => import('@/modules/users/views/pages/FinalizarPadrao.vue'),
      meta: {
        configurations: configurations
      }
    },
    {
      path: '/recuperar-senha',
      name: 'recuperar-senha',
      component: () => import('@/modules/users/views/pages/PasswordRecover.vue'),
      meta: {
        configurations
      }
    },
    {
      path: '/recuperar-senha-sms',
      name: 'recuperar-senha-sms',
      component: () => import('@/modules/users/views/pages/PasswordRecoverSms.vue'),
      meta: {
        configurations
      }
    },
    {
      path: '/email-enviado',
      name: 'email-enviado',
      component: () => import('@/modules/users/views/pages/PasswordRecoverSuccess'),
      meta: {
        configurations
      }
    },
    {
      path: '/nova-senha',
      name: 'nova-senha',
      component: () => import('@/modules/users/views/pages/PasswordNew.vue'),
      meta: {
        configurations
      }
    },
    {
      path: '/contato',
      name: 'contato',
      component: () => import('@/modules/units/views/pages/Contact.vue'),
      meta: {
        configurations
      }
    },
    {
      path: '/whatsapp/:tag?',
      name: 'whatsapp',
      alias: '/whatsapp-de-ofertas',
      component: () => import('@/modules/whatsapp/views/pages/WhatsApp.vue'),
      meta: {
        configurations
      }
    },
    {
      path: '/store-event-shortcode/:shortCode',
      name: 'store-event-shortcode',
      alias: '/e/:shortCode',
      component: () => import('@/modules/store-events/views/pages/StoreEventShortcode.vue')
    },
    {
      path: '/store-events/:eventId',
      name: 'store-event',
      component: () => import('@/modules/store-events/views/pages/StoreEvent.vue')
    },
    {
      path: '/w/:whatsappId',
      name: 'whatsapp-redirect',
      component: () => import('@/modules/whatsapp/views/pages/WhatsAppRedirect.vue'),
      meta: {
        configurations
      }
    },
    {
      path: '/survey/:surveyId',
      name: 'survey-id-entry',
      component: () => import('@/modules/survey/views/pages/SurveyIdEntry.vue')
    },
    {
      path: '/s/:shortCode',
      name: 'survey-shortcode-entry',
      component: () => import('@/modules/survey/views/pages/SurveyShortcodeEntry.vue')
    },
    {
      path: '/survey-information',
      name: 'survey-information',
      component: () => import('@/modules/survey/views/pages/SurveyInformation.vue'),
      props: route => ({ type: route.query.type })
    },
    {
      path: '/survey-form/:surveyId',
      name: 'survey-form',
      component: () => import('@/modules/survey/views/pages/SurveyForm.vue')
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/modules/errors/views/pages/404.vue')
    },
    {
      path: '*',
      component: () => import('@/modules/home/views/pages/HomePadrao.vue')
    }
  ]
}

module.exports = { router }
